import { default as SignaturePad } from "signature_pad";
import template from "./signatureElement.hbs";
import "./signature.scss";

export class SignatureElement extends HTMLElement {

    public static readonly DEFAULT_CANVAS_BACKGROUND_COLOR: string = 'rgb(255, 255, 255)';

    private signaturePad: SignaturePad;

    private containerDiv: HTMLDivElement;
    private canvas: HTMLCanvasElement;
    private clearButton: HTMLElement;
    private signatureTypeDataURL: string;

    constructor() {
        super();

        this.signatureTypeDataURL = this.getAttribute("signatureTypeDataURL");

        const optTemplate = {
            "prefixId": "sig",
            "id": this.getAttribute("_id"),
        } as any;

        this.innerHTML = template(optTemplate);

        this.containerDiv = this.querySelector(".c-signature__container");
        this.canvas = this.querySelector("canvas");
        this.signaturePad = new SignaturePad(this.canvas, {
            // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
            backgroundColor: SignatureElement.DEFAULT_CANVAS_BACKGROUND_COLOR
        });

        this.clearButton = this.querySelector(".c-signature__clear");

        this.bindEvents();
    }

    private bindEvents(): void {

        this.signaturePad.addEventListener("endStroke", () => {
            this.setClearButtonVisibility();
            this.dispatchEvent(new Event("change"));
        });

        this.clearButton.addEventListener("click", () => {
            console.log(this.getDataURL());
            this.signaturePad.clear();
            this.setClearButtonVisibility();
            this.dispatchEvent(new Event("change"));
        });
    }

    get data(): string {
        if (this.signaturePad.isEmpty()) {
            return null;
        } else {
            const data = this.getDataURL();
            return data;
        }
    }

    private getDataURL() {
        if (this.signatureTypeDataURL == SignatureTypeDataURL.JPEG) {
            return this.signaturePad.toDataURL("image/jpeg"); // save image as JPEG
        } else if (this.signatureTypeDataURL == SignatureTypeDataURL.SVG) {
            return this.signaturePad.toDataURL("image/svg+xml"); // save image as SVG
        } else {
            return this.signaturePad.toDataURL();
        }
    }

    set data(v: string) {
        if (v != null && v != undefined) {
            this.signaturePad.fromDataURL(v);
        }
        this.setClearButtonVisibility();
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.canvas.setAttribute("readOnly", "true");
            this.signaturePad.off();
        } else {
            this.canvas.removeAttribute("readOnly");
            this.signaturePad.on();
        }
        this.setClearButtonVisibility();
    }

    private setClearButtonVisibility() {
        if (this.data == null || this.signaturePad.isEmpty() || this.canvas.hasAttribute("readOnly")) {
            this.clearButton.style.visibility = "hidden";
        } else {
            this.clearButton.style.visibility = "visible";
        }
    }

    public postRender() {
        this.fitToContainer();
    }

    private fitToContainer() {
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';
        this.canvas.style.backgroundColor = SignatureElement.DEFAULT_CANVAS_BACKGROUND_COLOR;
        this.canvas.width = this.canvas.offsetWidth;
        this.canvas.height = this.canvas.offsetHeight;

        this.signaturePad.backgroundColor = SignatureElement.DEFAULT_CANVAS_BACKGROUND_COLOR;
    }

    public set valid(valid: boolean) {
        if (valid) {
            this.containerDiv.classList.remove("has-error");
            this.removeAttribute("data-tip");
        } else {
            this.containerDiv.classList.add("has-error");
        }
    }

    public set validationMessage(message) {
        if (message != null) {
            this.setAttribute("data-tip", message);
        }
    }
}

export enum SignatureTypeDataURL {
    PNG = "png",
    JPEG = "jpeg",
    SVG = "svg",
}

export function initSignatureWebComponent() {
    window.customElements.define("s6-signature", SignatureElement);
}
